module.exports = __webpack_public_path__ + "static/media/hornsoffa.4b83f895.jpg";